export default function updateActionCreators(resourceName, key, actionTypes, api) {
	if (resourceName == null) throw new Error('actionCreatorsFor: Expected resourceName');

	let actionCreators = {

		update: function (id, params, token) {
			return function (dispatch) {
				dispatch(actionCreators.request());

				return api.update(id, params, token)
					.then(
						response => dispatch(actionCreators.success(response)),
						error => dispatch(actionCreators.failure(error))
					).then(
						response => dispatch(actionCreators.complete()),
						error => dispatch(actionCreators.complete())
					);
			}
		},

		request: function () {
			let name = resourceName + '_UPDATE_REQUEST';

			return {
				type: actionTypes[name]
			}
		},

		success: function (data) {
			let name = resourceName + '_UPDATE_SUCCESS';
			return {
				data: data,
				type: actionTypes[name]
			}
		},

		complete: function () {
			let name = resourceName + '_UPDATE_COMPLETE';

			return {
				data: {},
				type: actionTypes[name]
			}
		},

		failure: function (error, data) {
			let name = resourceName + '_UPDATE_FAILURE';
			return {
				data: data,
				error: error,
				type: actionTypes[name]
			}
		}
	};

	return actionCreators;
}